// @generated by protoc-gen-es v1.10.1 with parameter "target=ts"
// @generated from file purchase_order/common.proto (package com.neulink.pharmacy, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import type { BinaryReadOptions, FieldList, JsonReadOptions, JsonValue, PartialMessage, PlainMessage } from "@bufbuild/protobuf";
import { Message, proto3, Timestamp } from "@bufbuild/protobuf";
import { ItemType } from "../inventory/common_pb.js";
import { TaxProfile } from "../medical_master/common_pb.js";
import { SupplierMetadata } from "../suppliers/common_pb.js";

/**
 * @generated from enum com.neulink.pharmacy.OrderStatus
 */
export enum OrderStatus {
  /**
   * Default value, not specified
   *
   * @generated from enum value: ORDER_STATUS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Purchase order is pending
   *
   * @generated from enum value: ORDER_STATUS_PENDING = 1;
   */
  PENDING = 1,

  /**
   * Purchase order has been completed
   *
   * @generated from enum value: ORDER_STATUS_COMPLETED = 2;
   */
  COMPLETED = 2,

  /**
   * Purchase order has been cancelled
   *
   * @generated from enum value: ORDER_STATUS_CANCELLED = 3;
   */
  CANCELLED = 3,

  /**
   * Purchase order has been rejected
   *
   * @generated from enum value: ORDER_STATUS_REJECTED = 4;
   */
  REJECTED = 4,

  /**
   * Purchase order has been accepted
   *
   * @generated from enum value: ORDER_STATUS_ACCEPTED = 5;
   */
  ACCEPTED = 5,
}
// Retrieve enum metadata with: proto3.getEnumType(OrderStatus)
proto3.util.setEnumType(OrderStatus, "com.neulink.pharmacy.OrderStatus", [
  { no: 0, name: "ORDER_STATUS_UNSPECIFIED" },
  { no: 1, name: "ORDER_STATUS_PENDING" },
  { no: 2, name: "ORDER_STATUS_COMPLETED" },
  { no: 3, name: "ORDER_STATUS_CANCELLED" },
  { no: 4, name: "ORDER_STATUS_REJECTED" },
  { no: 5, name: "ORDER_STATUS_ACCEPTED" },
]);

/**
 * @generated from message com.neulink.pharmacy.PurchaseOrderItem
 */
export class PurchaseOrderItem extends Message<PurchaseOrderItem> {
  /**
   * Unique identifier for the item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Quantity of the item to be ordered
   *
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * Optional bonus quantity for the item
   *
   * @generated from field: float bonus_quantity = 4;
   */
  bonusQuantity = 0;

  /**
   * Price per unit of the item
   *
   * @generated from field: float unit_price = 5;
   */
  unitPrice = 0;

  /**
   * Optional notes for the item
   *
   * @generated from field: string notes = 6;
   */
  notes = "";

  constructor(data?: PartialMessage<PurchaseOrderItem>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseOrderItem";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "bonus_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "unit_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 6, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseOrderItem {
    return new PurchaseOrderItem().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseOrderItem {
    return new PurchaseOrderItem().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseOrderItem {
    return new PurchaseOrderItem().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseOrderItem | PlainMessage<PurchaseOrderItem> | undefined, b: PurchaseOrderItem | PlainMessage<PurchaseOrderItem> | undefined): boolean {
    return proto3.util.equals(PurchaseOrderItem, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseOrderItemResponse
 */
export class PurchaseOrderItemResponse extends Message<PurchaseOrderItemResponse> {
  /**
   * Unique identifier for the item
   *
   * @generated from field: string master_id = 1;
   */
  masterId = "";

  /**
   * @generated from field: com.neulink.pharmacy.ItemType item_type = 2;
   */
  itemType = ItemType.UNSPECIFIED;

  /**
   * Quantity of the item to be ordered
   *
   * @generated from field: float quantity = 3;
   */
  quantity = 0;

  /**
   * Price per unit of the item
   *
   * @generated from field: float unit_price = 4;
   */
  unitPrice = 0;

  /**
   * Optional notes for the item
   *
   * @generated from field: string notes = 5;
   */
  notes = "";

  /**
   * Name of the item
   *
   * @generated from field: string trade_name = 6;
   */
  tradeName = "";

  /**
   * Unit of measurement for the item
   *
   * @generated from field: int32 unit = 7;
   */
  unit = 0;

  /**
   * Type of unit (e.g., "mg", "ml", "pcs")
   *
   * @generated from field: string unit_type = 8;
   */
  unitType = "";

  /**
   * Optional bonus quantity for the item
   *
   * @generated from field: float bonus_quantity = 9;
   */
  bonusQuantity = 0;

  /**
   * Tax profile associated with the item
   *
   * @generated from field: com.neulink.pharmacy.TaxProfile tax_profile = 10;
   */
  taxProfile?: TaxProfile;

  constructor(data?: PartialMessage<PurchaseOrderItemResponse>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseOrderItemResponse";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "master_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "item_type", kind: "enum", T: proto3.getEnumType(ItemType) },
    { no: 3, name: "quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 4, name: "unit_price", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "trade_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 7, name: "unit", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "unit_type", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "bonus_quantity", kind: "scalar", T: 2 /* ScalarType.FLOAT */ },
    { no: 10, name: "tax_profile", kind: "message", T: TaxProfile },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseOrderItemResponse {
    return new PurchaseOrderItemResponse().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseOrderItemResponse {
    return new PurchaseOrderItemResponse().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseOrderItemResponse {
    return new PurchaseOrderItemResponse().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseOrderItemResponse | PlainMessage<PurchaseOrderItemResponse> | undefined, b: PurchaseOrderItemResponse | PlainMessage<PurchaseOrderItemResponse> | undefined): boolean {
    return proto3.util.equals(PurchaseOrderItemResponse, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseOrder
 */
export class PurchaseOrder extends Message<PurchaseOrder> {
  /**
   * Unique identifier for the purchase order
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Unique order number
   *
   * @generated from field: string order_number = 2;
   */
  orderNumber = "";

  /**
   * ID of the supplier for the purchase order
   *
   * @generated from field: string supplier_id = 3;
   */
  supplierId = "";

  /**
   * List of items in the purchase order
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseOrderItemResponse items = 4;
   */
  items: PurchaseOrderItemResponse[] = [];

  /**
   * Optional notes for the purchase order
   *
   * @generated from field: string notes = 5;
   */
  notes = "";

  /**
   * Timestamp when the purchase order was created
   *
   * @generated from field: google.protobuf.Timestamp created_at = 6;
   */
  createdAt?: Timestamp;

  /**
   * Status of the purchase order (e.g., PENDING, COMPLETED)
   *
   * @generated from field: com.neulink.pharmacy.OrderStatus status = 7;
   */
  status = OrderStatus.UNSPECIFIED;

  /**
   * Name of the supplier
   *
   * @generated from field: string supplier_name = 8;
   */
  supplierName = "";

  /**
   * List of purchase request IDs associated with the purchase order
   *
   * @generated from field: repeated com.neulink.pharmacy.PurchaseRequestForOrder purchase_request_ids = 9;
   */
  purchaseRequestIds: PurchaseRequestForOrder[] = [];

  /**
   * Metadata about the supplier
   *
   * @generated from field: com.neulink.pharmacy.SupplierMetadata supplier_metadata = 10;
   */
  supplierMetadata?: SupplierMetadata;

  /**
   * ID of the stock point where the order is placed
   *
   * @generated from field: string stock_point_id = 11;
   */
  stockPointId = "";

  /**
   * Name of the stock point where the order is placed
   *
   * @generated from field: string stock_point_name = 12;
   */
  stockPointName = "";

  /**
   * ID of the purchase invoice associated with this order
   *
   * @generated from field: string purchase_invoice_id = 13;
   */
  purchaseInvoiceId = "";

  constructor(data?: PartialMessage<PurchaseOrder>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseOrder";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "supplier_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "items", kind: "message", T: PurchaseOrderItemResponse, repeated: true },
    { no: 5, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 6, name: "created_at", kind: "message", T: Timestamp },
    { no: 7, name: "status", kind: "enum", T: proto3.getEnumType(OrderStatus) },
    { no: 8, name: "supplier_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 9, name: "purchase_request_ids", kind: "message", T: PurchaseRequestForOrder, repeated: true },
    { no: 10, name: "supplier_metadata", kind: "message", T: SupplierMetadata },
    { no: 11, name: "stock_point_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "stock_point_name", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "purchase_invoice_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseOrder {
    return new PurchaseOrder().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseOrder {
    return new PurchaseOrder().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseOrder {
    return new PurchaseOrder().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseOrder | PlainMessage<PurchaseOrder> | undefined, b: PurchaseOrder | PlainMessage<PurchaseOrder> | undefined): boolean {
    return proto3.util.equals(PurchaseOrder, a, b);
  }
}

/**
 * @generated from message com.neulink.pharmacy.PurchaseRequestForOrder
 */
export class PurchaseRequestForOrder extends Message<PurchaseRequestForOrder> {
  /**
   * Unique identifier for the purchase request item
   *
   * @generated from field: string id = 1;
   */
  id = "";

  /**
   * Unique request number
   *
   * @generated from field: string request_number = 2;
   */
  requestNumber = "";

  constructor(data?: PartialMessage<PurchaseRequestForOrder>) {
    super();
    proto3.util.initPartial(data, this);
  }

  static readonly runtime: typeof proto3 = proto3;
  static readonly typeName = "com.neulink.pharmacy.PurchaseRequestForOrder";
  static readonly fields: FieldList = proto3.util.newFieldList(() => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "request_number", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ]);

  static fromBinary(bytes: Uint8Array, options?: Partial<BinaryReadOptions>): PurchaseRequestForOrder {
    return new PurchaseRequestForOrder().fromBinary(bytes, options);
  }

  static fromJson(jsonValue: JsonValue, options?: Partial<JsonReadOptions>): PurchaseRequestForOrder {
    return new PurchaseRequestForOrder().fromJson(jsonValue, options);
  }

  static fromJsonString(jsonString: string, options?: Partial<JsonReadOptions>): PurchaseRequestForOrder {
    return new PurchaseRequestForOrder().fromJsonString(jsonString, options);
  }

  static equals(a: PurchaseRequestForOrder | PlainMessage<PurchaseRequestForOrder> | undefined, b: PurchaseRequestForOrder | PlainMessage<PurchaseRequestForOrder> | undefined): boolean {
    return proto3.util.equals(PurchaseRequestForOrder, a, b);
  }
}

